import { useQuery } from '@tanstack/react-query'
import { AUTH_BYPASS } from '@/core/auth/dev-bypass'
import { useAuthStore } from '@/core/auth/auth-store'
import { playersPublicRepository } from './api/players-public-repository'

// `uid!` below is safe by the query's own gate: every one of these hooks sets
// `enabled: uid !== null` (or `!AUTH_BYPASS && uid !== null`), so TanStack
// Query never invokes the fn while uid is null. Asserting is preferable to a
// `?? ''` fallback, which would silently issue a query for the empty-string
// user and return an honest-looking empty result instead of not running.


/**
 * Another player's public trust facts (spec/06). `data === null` after a
 * successful fetch = no projection yet (brand-new player / guest) — surfaces
 * show the honest "sin datos todavía" state, never fabricated zeros.
 */
export function usePublicProfile(uid: string | null | undefined) {
  const me = useAuthStore((s) => s.user?.uid ?? null)
  return useQuery({
    queryKey: ['player-public', uid],
    queryFn: () => playersPublicRepository.getById(uid!),
    enabled: !AUTH_BYPASS && !!uid && me !== null,
    staleTime: 60_000,
  })
}
